/* eslint-disable */
import axios from '@/services/axios'

export default {
    getNaverAdData(search) {
        return axios.post("/keywordsearch/getNaverAdData", search);
    },    
    getDatalabData(search) {
        return axios.post("/keywordsearch/getDatalabData", search);
    },    
    getContentsData(search) {
        return axios.post("/keywordsearch/getContentsData", search);
    },  
    getNewsData(search) {
        return axios.get("/keywordsearch/getNewsData", { params: search });
    },    
};
